import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@mui/material";
import React from "react";
import { t } from "ttag";
import useStyles from "./DeviceManagement.style";
import {
  formatFirmwareProgressLabel,
  formatUpgradeVersionLabel,
} from "./firmwareUiUtils";

interface FirmwareUpgradeProgressDialogProps {
  open: boolean;
  versionInfo: { version: string; isStable?: boolean } | null;
  percent: number;
  secondsRemaining: number;
  stage?: string;
  completed: boolean;
  failed: boolean;
  onClose: () => void;
}

const FirmwareUpgradeProgressDialog = ({
  open,
  versionInfo,
  percent,
  secondsRemaining,
  stage,
  completed,
  failed,
  onClose,
}: FirmwareUpgradeProgressDialogProps) => {
  const styles: any = useStyles();
  const versionLabel = formatUpgradeVersionLabel(versionInfo);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
      <DialogTitle className={styles.firmwareProgressDialogTitle}>
        {failed ? t`Firmware update failed` : completed ? t`Firmware updated` : t`Updating firmware`}
      </DialogTitle>
      <DialogContent className={styles.firmwareProgressDialogContent}>
        <Typography className={styles.firmwareProgressSubtitle}>
          {completed ? t`Installed` : t`Installing`} {versionLabel}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={percent}
          color={failed ? "error" : "primary"}
          className={styles.firmwareProgressBar}
        />
        <Box className={styles.firmwareProgressMetaRow}>
          <Typography>{percent}%</Typography>
          <Typography>
            {formatFirmwareProgressLabel({
              completed,
              percent,
              secondsRemaining,
              stage: failed ? "error" : stage,
            })}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className={styles.firmwareProgressDialogActions}>
        <Button onClick={onClose}>
          {t`Close`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FirmwareUpgradeProgressDialog;
